var _defs, _polyline, _polyline2, _polyline3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhiteNoneAnim({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 584.9 252.5",
    height: "100px",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n.a,.c,.e{fill:none;}\n.a,.e{stroke:#fff;}\n.a,.b,.c,.d,.e,.f{stroke-miterlimit:10;}\n.a{stroke-width:1.5px;}\n.b,.d,.f,.g{fill:#fff;}\n.b,.d,.f{stroke-width:0.15px;}\n.b{stroke:url(#a);}\n.c{stroke:url(#b);}\n.d{stroke:url(#c);}\n.f{stroke:url(#d);}\n\n\n\n\n\n\n.g1 {\n \n  fill:#fff;\n  \n}   \n\n\n\n.g3 {\n \n  fill:#fff;\n  \n}   \n\n\n.g6 {\n \n  fill:#fff;\n  \n}   \n\n\n.g4 {\n \n  fill:#fff;\n  \n}   \n\n.g5 {\n \n  fill:#fff;\n  \n}   \n\n\n.g2 {\n \n  fill:#fff;\n  \n}   \n\n\n\n\n\n\n\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 290.48,
    y1: 236.5,
    x2: 306.88,
    y2: 236.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 283.36,
    y1: 236.5,
    x2: 313.99,
    y2: 236.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 132.78,
    y1: 13.5,
    x2: 143.45,
    y2: 13.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 566.69,
    y1: 105.5,
    x2: 577.35,
    y2: 105.5,
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "panther7 - Se - blue ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "242 158.5 298.2 237 358.4 207.4"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "281.7 44.4 138.6 14 154.8 36.7"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "512.5 131.7 566.8 105 543.2 100"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 298.7,
    cy: 236.5,
    rx: 8.1,
    ry: 8.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 298.7,
    cy: 236.5,
    rx: 14.8,
    ry: 15.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 138.1,
    cy: 13.5,
    rx: 5.3,
    ry: 5.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 138.1,
    cy: 13.5,
    rx: 12.4,
    ry: 13
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 572,
    cy: 105.5,
    rx: 5.3,
    ry: 5.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 572,
    cy: 105.5,
    rx: 12.4,
    ry: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g1",
    d: "M468.9,505.9s-14.8-19.3-37.3-15.3c-4.5.8-10.4,3.6-14.3,6.2-7.2,4.7-16.3,10.8-39.5,29.3,0,0-23.4,17-69.1,5.7,0,0-13-2.5-22.8-9.9a3.5,3.5,0,0,0-4-.2c-4.8,3.1-16.6,11.1-23.7,18.6a12.6,12.6,0,0,0-1.9,2.5A23.1,23.1,0,0,1,239,554.4h-7.8a1.9,1.9,0,0,0-1.8,1.7c-.8,4.8-1.7,17.8,11.3,16.8h.3c1.8-.8,15.8-7.6,23.6-15.8a30.8,30.8,0,0,1,10.9-7.8c6.5-2.8,17.2-5.5,33.2-4.7h12.8a2.3,2.3,0,0,1,2.1,2.6c-.3,4.6-2.7,13.9-16.4,19.3a5.4,5.4,0,0,0-3.1,3.3l-11.4,33s-3.6,8.3,4.5,19.4a1.1,1.1,0,0,0,1,.5h16a1.1,1.1,0,0,0,1.1-.6c1.1-2.1,3.6-8.7-6.2-13.4a1.4,1.4,0,0,1-.6-.7c-.7-1.7-2.9-8.1.2-16.5h0c.6-1.3,10.1-20.4,27.2-21.2a1.4,1.4,0,0,0,1.2-1.4,1.4,1.4,0,0,1,1.2-1.5c3.6-.2,16.4-3.7,46.9-26.6,0,0,8.9-6.2,16.2-23.4a11.5,11.5,0,0,1,5.7-6c8.3-3.9,29.3-8,57.1,13.3,0,0,10.8,8.3,29.4,4.7a1.5,1.5,0,0,0,.5-2.6C491,524.1,479.9,521.6,468.9,505.9Z",
    transform: "translate(-211.4 -374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g2",
    d: "M260.6,445c17.4,2.9,49.4,9,59.4,11.4h.2l6.1.7h.1c6.8.4,13.3.4,17.3-.2a1.3,1.3,0,0,1,1.4,1.8c-2.3,7.7-10.5,32.2-21.9,38.1-.3.1-.2.7.2.6,6.7-.7,26.3-4,33.4-16.8h.1c.8-1.7,20.5-43.8,42.2-46.7a45.5,45.5,0,0,0,7.3-1.7,26.9,26.9,0,0,1,8.4-1.3h1.8c1.4,0,1.7-2.4.3-2.8a79.8,79.8,0,0,0-38.5-.5l-3.4,1.1c-7.2,2.9-38,14.5-65,10.8-30.9-4.3-64.2-14.3-80.3-5.7,0,0-25.5,11.2-15,36.4a1.8,1.8,0,0,0,.8.7c1.5.5,5.4,1.1,4.4-5.9C219.9,464.9,217.4,437.9,260.6,445Z",
    transform: "translate(-211.4 -374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g3",
    d: "M665.2,433.2a1.2,1.2,0,0,0,1.9.9,12,12,0,0,0,4.2-9V414.5a1.4,1.4,0,0,1,1.3-1.5h2.9l.6.2,36.4,25.2a1.4,1.4,0,0,1,.6,1.2v8.8a6.7,6.7,0,0,0,1.5,4.2l11.9,13.7s3,3.5-4.4,5.2c0,0-3,1.7,2.9,3.4a8.7,8.7,0,0,1,4,3.3,1.2,1.2,0,0,0,2,.1c1.7-2.3,4.5-6.2,4.5-8.5,0,0,1.5-3.5-3-10.3a73.6,73.6,0,0,1-5-9.5,39,39,0,0,1-3.1-11.1l-.8-6.3a1.2,1.2,0,0,0-.5-1l-21.5-16.5a1.2,1.2,0,0,1-.5-1c-.4-2.9-2.4-15.2-9.9-10a1.1,1.1,0,0,0-.5.9c-.2.9-1.1,2.9-4.5,2.9,0,0-1.4,1.7-5.7-4.9l-.5-.4c-1.6-.8-9.1-4.4-14.5,0l-.3.3-4.1,6.3a2.9,2.9,0,0,0-.2.9v11.2a2,2,0,0,0,.1.7A46.5,46.5,0,0,1,665.2,433.2Z",
    transform: "translate(-211.4 -374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g4",
    d: "M628.5,539.9c-8.1-2.1-18.3-3.1-33.3-3.1H547a17.3,17.3,0,0,1-12.6-5.4c-5.9-6.3-9.8-19.3,8.8-44.4.7-1,.2-2.4-.9-2.4a5.1,5.1,0,0,0-3.4,1.4c-11.2,10.9-53,54.5-17.3,65.6a12.9,12.9,0,0,0,4.3.7h97.2a4.8,4.8,0,0,1,4.3,2.8c1,2.2.5,5.3-7.5,7.3a13.9,13.9,0,0,0-1.9.6c-4,1.7-16.5,8.3-6.4,21.8a4.7,4.7,0,0,0,3.8,1.9c4.7-.2,15.6-2,25.8-13.4a4.1,4.1,0,0,0,.5-.9l1.3-2.9C646.9,556.3,640.2,543.1,628.5,539.9Z",
    transform: "translate(-211.4 -374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "M556.5,444c20.6-16.8,32.8-17.2,36-17.4h3.1c4.1.2,16.9.5,26.4,12.8,1,1.3,2.9.7,3.1-1.1.7-6.8,4.3-17.7,19.3-20.1h4.5a1.4,1.4,0,0,0,.9-2.4l-.8-1c-1.3-1.5-18.3,2.1-22.8,3.2a8.3,8.3,0,0,0-2.1.6h-.2l-6.8,4.1a1.3,1.3,0,0,1-1.6-.4c-.6-.9-1.4-1.8-2.4-.8s-12.3-.3-26.7-4.6a23.3,23.3,0,0,0-3.6-.8c-3.2-.4-9.3-1-11.4.3,0,0-46.1,24.4-67.7,26a1.5,1.5,0,0,0-.4,2.7C513.4,450.5,537.1,459.7,556.5,444Z",
    transform: "translate(-211.4 -374)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g6",
    d: "M727,539.5a102.6,102.6,0,0,0-12.3-8.6,48.5,48.5,0,0,0-15.6-6.2,504.3,504.3,0,0,0-52.3-6.6,1.7,1.7,0,0,1-1.1-2.5,92.7,92.7,0,0,0,7.7-23.4V492c.2-1.2,2-18.3,14.9-5.1h.1l4,4.6a1.1,1.1,0,0,0,1.1.4c3.4-.8,20.2-3.9,33.5,5.2h.2c.7.3,5.2,1.9,8.4-1.6.8-.9.1-2.6-1.1-2.4s-5.6-.3-7.3-6.2a.3.3,0,0,1-.1-.2c-.5-1.1-5.6-10-23.7-6.9h-.3c-1,.6-9.1,3.9-21-8.9a21.3,21.3,0,0,0-3.1-2.9l-.4-.2-4.4-1.7h-16a1.4,1.4,0,0,0-1.2,1.4v12.5c-.1,1.3-2.3,19-25.9,30.7a1.5,1.5,0,0,0,.3,2.7c13.6,3.1,55.6,14.2,50.2,33.4a1.3,1.3,0,0,0,1.1,1.8h44a1.1,1.1,0,0,1,.8.3l11.1,10a9.5,9.5,0,0,1,2.4,9.8,9.7,9.7,0,0,0,1.2,8.5c1.3,1.9,3.3,4.1,5.8,4.1h4.1a8,8,0,0,0,5.3-1.9,6.3,6.3,0,0,0,2.6-5v-6.4C740,556.8,735.1,546,727,539.5Z",
    transform: "translate(-211.4 -374)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteNoneAnim);
export default __webpack_public_path__ + "static/media/logo-white-none-anim.5bd1e19c2dd470fa239981e2d61368de.svg";
export { ForwardRef as ReactComponent };